import * as React from 'react';
import {useStore} from 'react-redux';

import matchSorter from 'match-sorter';
import debounce from 'lodash/debounce';
import {Gif} from '@giphy/react-components';
import {GiphyFetch} from '@giphy/js-fetch-api';

import {debounceAsync} from 'src/utils/index';
import Loading from 'src/components/lib/loading/index';

import css from './gif-picker.css';


const searchGif = (searchString: string, gf: any) => {
  if (searchString) {
    return gf.search(searchString);
  }
  return;
};
const searchGifDebounced = debounceAsync(searchGif, 1000);

export default function GifPicker({
  onClose,
  onSelect,
}: {
  onClose: () => unknown;
  onSelect: (arg1: unknown) => void;
}) {
  const reduxStore = useStore();
  const giphyKey = reduxStore.getState().env.vendorIds.giphy;
  const gf = new GiphyFetch(giphyKey);
  const [gifs, setGif] = React.useState<any>(null);
  React.useEffect(() => {
    gf.trending({offset: 15, limit: 15}).then(({data}) => setGif(data));
  }, []);

  const [searchString, setSearchString] = React.useState('');

  const handleSearchStringChange = async (text: any) => {
    setSearchString(text);
    const result = await searchGifDebounced(text, gf);
    // @ts-expect-error - TS18046 - 'result' is of type 'unknown'.
    if (result.data) {
      // @ts-expect-error - TS18046 - 'result' is of type 'unknown'.
      setGif(result.data);
    }
  };

  return (
    <div className={css.root}>
      <input
        type="search"
        placeholder="Search gifs..."
        className={css.searchInput}
        value={searchString}
        onChange={(e) => {
          handleSearchStringChange(e.target.value);
        }}
      />
      {gifs && (
        <div className={css.gifContainer}>
          {/* @ts-expect-error - TS7006 - Parameter 'gif' implicitly has an 'any' type. */}
          {gifs.map((gif) => (
            // @ts-expect-error - TS2786 - 'Gif' cannot be used as a JSX component.
            <Gif
              noLink
              gif={gif}
              width={180}
              onGifClick={() => {
                onSelect(gif);
                onClose();
              }}
            />
          ))}
        </div>
      )}
      <img src="/images/powered-by-giphy.png" className={css.poweredBy} />
    </div>
  );
}
